import React from "react";

const STATUS_STYLES = {
  APPROVED: { color: "#4caf50", bg: "rgba(76,175,80,0.12)" },
  ACTIVE: { color: "#4caf50", bg: "rgba(76,175,80,0.12)" },
  RECEIVED: { color: "#4caf50", bg: "rgba(76,175,80,0.12)" },
  CREDIT: { color: "#4caf50", bg: "rgba(76,175,80,0.12)" },
  PENDING_APPROVAL: { color: "#e8b84b", bg: "rgba(232,184,75,0.12)" },
  PENDING_SHIPMENT: { color: "#e8b84b", bg: "rgba(232,184,75,0.12)" },
  LABEL_PENDING: { color: "#e8b84b", bg: "rgba(232,184,75,0.12)" },
  PENDING: { color: "#e8b84b", bg: "rgba(232,184,75,0.12)" },
  IN_TRANSIT: { color: "#af58f2", bg: "rgba(175,88,242,0.12)" },
  SHIPPED: { color: "#af58f2", bg: "rgba(175,88,242,0.12)" },
  DELAYED: { color: "#af58f2", bg: "rgba(175,88,242,0.12)" },
  REJECTED: { color: "#f27059", bg: "rgba(242,112,89,0.12)" },
  EXPIRED: { color: "#f27059", bg: "rgba(242,112,89,0.12)" },
  CANCELLED: { color: "#f27059", bg: "rgba(242,112,89,0.12)" },
  DEBIT: { color: "#f27059", bg: "rgba(242,112,89,0.12)" },
  QUOTE_PENDING: { color: "#e8b84b", bg: "rgba(232,184,75,0.12)" },
  QUOTE_APPROVED: { color: "#4caf50", bg: "rgba(76,175,80,0.12)" },
  QUOTE_ACCEPTED: { color: "#4caf50", bg: "rgba(76,175,80,0.12)" },
  QUOTE_REJECTED: { color: "#f27059", bg: "rgba(242,112,89,0.12)" },
  QUOTE_DENIED: { color: "#f27059", bg: "rgba(242,112,89,0.12)" },
  INACTIVE: { color: "#f27059", bg: "rgba(242,112,89,0.12)" },
  PRE_TRANSIT: { color: "#e8b84b", bg: "rgba(232,184,75,0.12)" },
  PAYMENT_PENDING: { color: "#e8b84b", bg: "rgba(232,184,75,0.12)" },
  CREDIT_PENDING: { color: "#e8b84b", bg: "rgba(232,184,75,0.12)" },
  EARLY_PAYMENT: { color: "#22d3ee", bg: "rgba(34,211,238,0.12)" },
  EARLY_CREDIT: { color: "#22d3ee", bg: "rgba(34,211,238,0.12)" },
  PAYMENT_READY: { color: "#4caf50", bg: "rgba(76,175,80,0.12)" },
  CREDIT_READY: { color: "#4caf50", bg: "rgba(76,175,80,0.12)" },
  PAYMENT_DONE: { color: "#4caf50", bg: "rgba(76,175,80,0.12)" },
  CREDIT_DONE: { color: "#4caf50", bg: "rgba(76,175,80,0.12)" },
  PAYMENT_DENIED: { color: "#f27059", bg: "rgba(242,112,89,0.12)" },
  CREDIT_DENIED: { color: "#f27059", bg: "rgba(242,112,89,0.12)" },
  RECEIVING_DELAY: { color: "#e8b84b", bg: "rgba(232,184,75,0.12)" },
  READY_FOR_REDEMPTION: { color: "#22d3ee", bg: "rgba(34,211,238,0.12)" },
  PROCESSING: { color: "#22d3ee", bg: "rgba(34,211,238,0.12)" },
  ACTION_REQUIRED: { color: "#f0a500", bg: "rgba(240,165,0,0.12)" },
  FAILED: { color: "#f27059", bg: "rgba(242,112,89,0.12)" },
};

const DEFAULT_STYLE = { color: "#c3c8cc", bg: "rgba(255,255,255,0.06)" };

function formatLabel(status) {
  if (!status) return "—";
  return status.replace(/_/g, " ");
}

export default function StatusBadge({ status, label }) {
  const style = STATUS_STYLES[status] || DEFAULT_STYLE;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "3px 10px",
        borderRadius: 9999,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: "0.02em",
        color: style.color,
        background: style.bg,
        whiteSpace: "nowrap",
      }}
    >
      {label || formatLabel(status)}
    </span>
  );
}
